// extracted by mini-css-extract-plugin
module.exports = {"Voices":"Voices_Voices__576YJ"};